import { render, staticRenderFns } from "./CustomerSketch.vue?vue&type=template&id=099a1ef9&"
import script from "./CustomerSketch.vue?vue&type=script&lang=js&"
export * from "./CustomerSketch.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSketch.vue?vue&type=style&index=0&id=099a1ef9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports